import { createAction } from 'typesafe-actions';

import * as ActionTypes from './actionTypes';
import { NewnityEntityType, IdName } from './types';

export const entityListRequest = createAction(
  ActionTypes.ENTITY_LIST_REQUEST,
  action => (entityType: NewnityEntityType) => action({ entityType })
);

export const entityListSuccess = createAction(
  ActionTypes.ENTITY_LIST_SUCCESS,
  action => (entityType: NewnityEntityType, items: IdName[]) => action({ entityType, items })
);

export const entityListClear = createAction(
  ActionTypes.ENTITY_LIST_CLEAR,
  action => (entityType: NewnityEntityType) => action({ entityType })
);

export const entityListError = createAction(
  ActionTypes.ENTITY_LIST_ERROR,
  action => (entityType: NewnityEntityType, error: string) => action({ entityType, error })
);

export const entityUpsert = createAction(
  ActionTypes.ENTITY_UPSERT,
  action => (entityType: NewnityEntityType, item: IdName) => action({ entityType, item })
);

export const entityDelete = createAction(
  ActionTypes.ENTITY_DELETE,
  action => (entityType: NewnityEntityType, item: IdName) => action({ entityType, item })
);
